const news_en = require('./news.json')
export default news_en